import Vue from 'vue';
const resource = '/orders';

export default {
  closeOrder(idPublic) {
    return Vue.prototype.$axiosMainClient.put(`${resource}/${idPublic}/close`);
  },
  automaticCreation(payload) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/automaticcreation`,
      payload
    );
  },
  orderOrder(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/order`,
      payload
    );
  },
};
